import { render } from "./archiveTemplates.vue?vue&type=template&id=bc516070&scoped=true&ts=true"
import script from "./archiveTemplates.vue?vue&type=script&lang=ts"
export * from "./archiveTemplates.vue?vue&type=script&lang=ts"

import "./archiveTemplates.vue?vue&type=style&index=0&id=bc516070&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc516070"]])

export default __exports__